import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { Store } from '@sama/app-state';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ShapeState2D } from '../../../../cross-team-shared/annotation/shared/state/shape-state';
import { Point2D } from '../../../../team-apis/otterdam/answers/shape-typings';
import { AbstractSensorContentStore2D } from '../../state/abstract-sensor-content-store-2d';
import { LocationHelper, makeLocation$ } from '../../utils/location-helper';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector -- svg needs attribute selectors
  selector: '[h3ModelInputPoints]',
  templateUrl: './model-input-points.component.html',
  styleUrls: ['./model-input-points.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ModelInputPointsComponent implements OnInit {
  @Input({ required: true }) shapeStore!: Store<ShapeState2D>;
  points$!: Observable<Point2D[] | undefined>;
  private store = inject(AbstractSensorContentStore2D);

  ngOnInit() {
    this.points$ = makeLocation$(
      new LocationHelper(this.store),
      this.store('frameNumber').$,
      this.shapeStore('key_locations').$,
    ).pipe(map((location) => location.model_input_points));
  }
}
